module.exports = __webpack_public_path__ + "img/icon-settings.e63c29ad.svg";